// types
import { Block } from 'baseui/block';
import { Input } from 'baseui/input';
import { LabelMedium } from 'baseui/typography';
import { FormattedMessage } from 'react-intl';
import { ParametersViewWrapper } from '../../../../features/ParametersView';
import { useSetObjectValue } from '../../../../hooks/useSetObjectValue';
import { IAHU_Optimizer } from './types'


export function ConfigurationPanel(props: IAHU_Optimizer) {

    const [heatSetpoint, setHeatSetpoint, setHeatSetpointResult] = useSetObjectValue(props.id, props.resourceGroupId, "setpointHeat", props.setpointHeat);
    const onHeatSetpointChanged = (e: any) => setHeatSetpoint(parseFloat(e.target.value));

    const [coolSetpoint, setCoolSetpoint, setCoolSetpointResult] = useSetObjectValue(props.id, props.resourceGroupId, "setpointCool", props.setpointCool);
    const onCoolSetpointChanged = (e: any) => setCoolSetpoint(parseFloat(e.target.value));

    const [aQSetpoint, setAQSetpoint, setAQSetpointResult] = useSetObjectValue(props.id, props.resourceGroupId, "setpointAQ", props.setpointAQ);
    const onAQSetpointChanged = (e: any) => setAQSetpoint(parseFloat(e.target.value));

    const [outMin, setOutMin, setOutMinResult] = useSetObjectValue(props.id, props.resourceGroupId, "outMin", props.outMin);
    const onOutMinChanged = (e: any) => setOutMin(parseFloat(e.target.value));

    const [outMax, setOutMax, setOutMaxResult] = useSetObjectValue(props.id, props.resourceGroupId, "outMax", props.outMax);
    const onOutMaxChanged = (e: any) => setOutMax(parseFloat(e.target.value));

    return ( 
<Block gridRowGap='20px' display='flex'flexDirection='column' >
                <LabelMedium><FormattedMessage id="AHU_Optimizer.setpointHeat" defaultMessage="Setpoint Heat" /></LabelMedium>
                <Input
                    value={heatSetpoint}
                    onChange={onHeatSetpointChanged}
                    placeholder=""
                    endEnhancer={"°C"}
                    disabled={setHeatSetpoint.isLoading}
                    error={setHeatSetpoint.isError}
                />
                <LabelMedium><FormattedMessage id="AHU_Optimizer.setpointCool" defaultMessage="Setpoint Cool" /></LabelMedium>
                <Input
                    value={coolSetpoint}
                    onChange={onCoolSetpointChanged}
                    placeholder=""
                    endEnhancer={"°C"}
                    disabled={setCoolSetpoint.isLoading}
                    error={setCoolSetpoint.isError}
                />
                <LabelMedium><FormattedMessage id="AHU_Optimizer.setpointAQ" defaultMessage="Setpoint Air Quality" /></LabelMedium>
                <Input
                    value={aQSetpoint}
                    onChange={onAQSetpointChanged}
                    placeholder=""
                    endEnhancer={"ppm"}
                    disabled={setAQSetpoint.isLoading}
                    error={setAQSetpoint.isError}
                />
                <LabelMedium><FormattedMessage id="AHU_Optimizer.outMin" defaultMessage="Minimum Pressure" /></LabelMedium>
                <Input
                    value={outMin}
                    onChange={onOutMinChanged}
                    placeholder=""
                    endEnhancer={"Pa"}
                    disabled={setOutMin.isLoading}
                    error={setOutMin.isError}
                />
                <LabelMedium><FormattedMessage id="AHU_Optimizer.outMax" defaultMessage="Maximum Pressure" /></LabelMedium>
                <Input
                    value={outMax}
                    onChange={onOutMaxChanged}
                    placeholder=""
                    endEnhancer={"Pa"}
                    disabled={setOutMax.isLoading}
                    error={setOutMax.isError}
                />
               
            </Block>
    );
}

